import styled from 'styled-components';

export const FileUploaderInput = styled.input((props) => ({
  width: '100%',
  height: '100%',
  opacity: 0,
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 999,
  border: '1px solid red',
}));

const FileInput = styled.input`
  position: absolute;
  z-index: -1;
  top: 0;
`;

export default FileInput;
